(function (){
    'use strict';


    var extDeps = ['angularMoment'];
    var module = angular.module('app.common.widgets.calendar',extDeps);




    /**
     * CONTROLLERS
     */

    module.directive("commonCalendar",commonCalendarDirective);
    commonCalendarDirective.$inject =['calendarService'];
    function commonCalendarDirective(calendarService) {

        Controller.$inject = ['$scope'];

        return {
            restrict: "E",
            templateUrl: "/UI/app/common.widgets/calendar.html",
            scope: {
                eventsData: '='
                , selectedRanges:'='
                , dateDisplayed: '='
                , showToolbar: '='
                , onDateSelected : '&'
            },
            controller: Controller,
            controllerAs:'vm'
        };


        function Controller($scope){

            var vm = this;
            vm.weeks = [];
            vm.raiseDateSelected = raiseDateSelected;
            vm.gotoNextMonth = gotoNextMonth;
            vm.gotoPreviousMonth = gotoPreviousMonth;
            vm.buildMonth = buildMonth;
            init();




            function init(){
                //
                //$scope.$watch('dateDisplayed' , function(nv) {
                //
                //    if(!nv || !nv._isAMomentObject) {
                //        vm.weeks = [];
                //        return;
                //    }
                //
                //    // NOTE: there is some smeliness in angular. ov === nv the first time the watcher is fired
                //    // https://github.com/angular/angular.js/issues/11565
                //    //if(nv.diff(ov,'months') !== 0){
                //    //    vm.buildMonth();
                //    //}
                //
                //    vm.buildMonth();
                //
                //}, true);

                $scope.$watch('eventsData' , function(nv,ov) {
                    if(nv !== ov && nv){
                        vm.buildMonth();
                        //console.log('test', ov,nv)
                    }

                }, true);

                $scope.$watch('selectedRanges', function(nv){
                    if(!nv) return;
                    expandWeeksWithRangesData(vm.weeks);
                });

            }



            function raiseDateSelected(day) {
                if($scope.onDateSelected)
                    $scope.onDateSelected({date:day.date});
            }

            function gotoPreviousMonth() {
                $scope.dateDisplayed.add(-1,'months').date(1);
            }

            function gotoNextMonth() {
                $scope.dateDisplayed.add(1,'months').date(1);
            }

            function buildMonth() {
                if(!$scope.dateDisplayed)
                    return;

                var doesWeekStartOnSunday = true;

                // gets a plain month calendar and decorates it with the input data
                calendarService.getWeekListForMonthAsync($scope.dateDisplayed, doesWeekStartOnSunday)
                    .then(function(results){

                        // extends the month calendar with events
                        expandResultsWithEventData($scope.eventsData, results);

                        // extends the month calendar with the current highlighted selection
                        expandWeeksWithRangesData(results);

                        vm.weeks = results;
                    });
            }

            function expandResultsWithEventData(events, weeks){
                if(!events)
                    return;

                    events.forEach(function(x){
                       //angular.extend(, x);
                        var day = weeks.getDayAt(x.date);
                        if(day)
                            angular.extend(day, x);
                    });

            }

            function expandWeeksWithRangesData(weeks){

                if(weeks.length === 0) return;

                var list = [];
                angular.copy($scope.selectedRanges, list);
                if(angular.isArray(list) === false)
                    return;


                var rangeStylesMap = {};
                list
                    .filter(function(range){

                        // filters out the bad ranges first
                        var sdOk = range && range.startDate && range.startDate._isAMomentObject;
                        if(!sdOk) return false;

                        var edOk = range && range.endDate && range.endDate._isAMomentObject;
                        if(edOk && range.endDate.diff(range.startDate,'days') < 0)
                            return false;

                        if(!edOk)
                            range.endDate = null;

                        return true;
                    })
                    .forEach(function(range){
                        // processes each ranges
                        var d = range.startDate.clone()
                            , ed = range.endDate;

                        rangeStylesMap[d.format('YYYY-MM-DD')] = ['selected'];
                        if(!ed) return;

                        d.add(25,'hours').hours(1); // momentjs had a twitch with daylight savings and was moving 23 hours fwd with add days
                        var doneTweenStart, dateDiff;
                        while((dateDiff = ed.diff(d,'days')) >= 1){

                            var styles = ['tween'];
                            if(!doneTweenStart) {
                                styles.push('start');
                                doneTweenStart = true;
                            }
                            if(dateDiff === 1)
                                styles.push('end');
                            rangeStylesMap[d.format('YYYY-MM-DD')] = styles;
                            d.add(25,'hours').hours(1) ;// momentjs had a twitch with daylight savings and was moving 23 hours fwd with add days;
                        }
                        rangeStylesMap[range.endDate.format('YYYY-MM-DD')] = ['selected'];
                    });

                //tween start
                weeks.getAllDays().forEach(function(day){
                    day.rangeStyles = rangeStylesMap[day.date.format('YYYY-MM-DD')];
                });
            }
        }



    }




    /**
     * SERVICES
     */




    module.factory("calendarService",calendarService);
    calendarService.$inject=['$q','moment'];
    function calendarService($q,moment){


        init();

        return {
            getWeekListForMonthAsync:getWeekListForMonthAsync
        };


        //function getWeekListForMonthAsync(momentDate,doesWeekStartOnSunday){
        //
        //    var startOfMonthDate = momentDate.clone().date(1);
        //    var m = startOfMonthDate.clone().day(doesWeekStartOnSunday ? 0 :1);
        //    var todayString = moment().format('YYYY-MM-DD');
        //
        //    var daysMap = {
        //        allItems:[]
        //        , addDay : function(day){
        //            var key = day.date.format('YYYY-MM-DD');
        //            this[key] = day;
        //            this.allItems.push(day);
        //        }
        //    };
        //
        //    var weeksMap = {
        //        addWeek : function(week){
        //            var self = this;
        //            week.days.forEach(function(day){
        //                var key = day.date.format('YYYY-MM-DD');
        //                self[key] = week;
        //            });
        //        }
        //    };
        //
        //    function createNextDay(refDate){
        //        var date = refDate.clone();
        //        //var date = moment(refDate.format('YYYY-MM-DD'),'YYYY-MM-DD');
        //        var day = {
        //            date : date
        //            , events: []
        //            , isCurrentMonth: m.month() === startOfMonthDate.month()
        //            , isToday: todayString === date.format('YYYY-MM-DD')
        //        };
        //        daysMap.addDay(day);
        //        return day;
        //    }
        //
        //
        //    var rt = [];
        //    while(m.diff(startOfMonthDate,'months') < 1 ){
        //
        //        var days = [];
        //        for(var i=0;i< 7;i++) {
        //            days.push(createNextDay(m));
        //            m.add(25,'hours').hours(1); // momentjs had a twitch with daylight savings and was moving 23 hours fwd with add days
        //        }
        //
        //        var week = { days: days };
        //        weeksMap.addWeek(week);
        //        rt.push(week);
        //    }
        //
        //
        //    rt.getDayAt = function(date){
        //        return daysMap[moment(date).format('YYYY-MM-DD')];
        //    };
        //
        //    rt.getAllDays = function(){
        //        return daysMap.allItems;
        //    };
        //
        //    rt.getWeekAt = function(date){
        //        return weeksMap[moment(date).format('YYYY-MM-DD')];
        //    };
        //
        //    return $q.resolve(rt);
        //}

        function getWeekListForMonthAsync(momentDate,doesWeekStartOnSunday){

            var startOfMonthDate = momentDate.clone().date(1);
            var m = startOfMonthDate.clone().day(doesWeekStartOnSunday ? 0 :1);
            var todayString = moment().format('YYYY-MM-DD');



            function createNextDayInCalendar(cal,refDate){
                var date = refDate.clone();
                //var date = moment(refDate.format('YYYY-MM-DD'),'YYYY-MM-DD');
                var day = {
                    date : date
                    , events: []
                    , isCurrentMonth: m.month() === startOfMonthDate.month()
                    , isToday: todayString === date.format('YYYY-MM-DD')
                };
                cal._daysMap.addDay(day);
                return day;
            }


            var rt = new Calendar();
            while(m.diff(startOfMonthDate,'months') < 1 ){

                var days = [];
                for(var i=0;i< 7;i++) {
                    days.push(createNextDayInCalendar(rt,m));
                    m.add(25,'hours').hours(1); // momentjs had a twitch with daylight savings and was moving 23 hours fwd with add days
                }

                var week = { days: days };
                rt._weeksMap.addWeek(week);
                rt.push(week);
            }


            return $q.resolve(rt);
        }

        function init(){
            Calendar.prototype = new Array;

            Calendar.prototype.getDayAt = function(date){
                return this._daysMap[moment(date).format('YYYY-MM-DD')];
            };

            Calendar.prototype.getAllDays = function(){
                return this._daysMap.allItems;
            };

            Calendar.prototype.getWeekAt = function(date){
                return this._weeksMap[moment(date).format('YYYY-MM-DD')];
            };
        }


        function Calendar(){
            this._daysMap = {
                allItems:[]
                , addDay : function(day){
                    var key = day.date.format('YYYY-MM-DD');
                    this[key] = day;
                    this.allItems.push(day);
                }
            };

            this._weeksMap = {
                addWeek : function(week){
                    var self = this;
                    week.days.forEach(function(day){
                        var key = day.date.format('YYYY-MM-DD');
                        self[key] = week;
                    });
                }
            };
        }

    }





    module.factory('dateService', dateService );
    dateService.$inject=['$rootScope','$timeout'];
    function dateService($rootScope,$timeout){
        var _dateValue = null;
        var handlerCache = {};
        return {
            getTodayDate : _getTodayDate
            , setDate: _setDate
            , onDateChanged:_onDateChanged
            , reset: _reset
            , getDate: _getDate
        };



        function _reset(){
            _dateValue = _getTodayDate();
            _notify();
        }

        function _setDate(date){
            if(!date) return;
            var momentDate = date._isAMomentObject ? date : moment(date);
            if(momentDate.isValid() == false)
                return;

            _dateValue = momentDate.clone();
            _notify();
        }

        function _getDate(){
            return _dateValue.clone();
        }

        function _onDateChanged( handler){
            if(!handler)
                return;

            var key = handler.toString();

            // unregister previous handler
            if(handlerCache[key]){
                handlerCache[key]();
            }

            handlerCache[key] = $rootScope.$on('dateService.message.newDateIsAvailable', handler);
        }

        function _getTodayDate(){
            return moment().hours(0).minutes(0).seconds(0).milliseconds(0);
        }

        function _notify(){
            $timeout(function(){
                $rootScope.$emit("dateService.message.newDateIsAvailable");
            },0);

        }
    }



})();

